module.exports = __webpack_public_path__ + "static/logo.0f770fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 865
// module chunks = 226573449209678